// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';


import './index.css';
import App from './App/App';

const Index = () => {


  return (
    <React.StrictMode>
      <BrowserRouter>
       
          <App />
     
      </BrowserRouter>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<Index />);
